import axiosInstance from '../axiosInstance';


class Auth {
  /**
   * Authenticate a user. Save a token string in Local Storage
   *
   * @param {string} token
   */
  static authenticateUser(token, user) {
    localStorage.setItem('accessToken', token);
    localStorage.setItem('userData', user);
  }
  static authenticateUserV(token, user) {
    localStorage.setItem('accessTokenV', token);
    localStorage.setItem('userData', user);
  }
  /**
   * Check if a user is authenticated - check if a token is saved in Local Storage
   *
   * @returns {boolean}
   */
  static isUserAuthenticated() {
    return localStorage.getItem('accessToken') !== null;
  }
  static isUserAuthenticatedV() {
    return localStorage.getItem('accessTokenV') !== null;
  }
  
 static async authenticate(code, type) {
    axiosInstance.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        if (error.response && error.response.status === 401) {
         return false;
        }
      }
    );
   const res = await axiosInstance
      .post("/auth/login", {
        code,
        type
      });
      if (res) {
        if (res && res.status === 200) {
          // save the token
          if (type==="VOLUNTAR") {
            //console.log('ressss', res)
            localStorage.setItem('volunteerId', res.data.user._id);
            Auth.authenticateUserV(res.data.token, res.data.user);
          } else {
            Auth.authenticateUser(res.data.token, res.data.user);
          }
          
          return true;
        } else if (res && res.status === 401) {
          return false;
        } else {
          return false;
        }
      };
  }


  /**
   * Deauthenticate a user. Remove a token from Local Storage.
   *
   */
  static deauthenticateUser() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('accessTokenV');
    localStorage.removeItem('userData');
    
  }

  /**
   * Get a token value.
   *
   * @returns {string}
   */

  static getToken() {
    return localStorage.getItem('accessToken');
  }
  static getTokenVolunteer() {
    return localStorage.getItem('accessTokenV');
  }
  /**
   * Get a token value.
   *
   * @returns {string}
   */

}

export default Auth;